import React from "react";
import { Breadcrumb,Grid } from 'react-bootstrap'

class Breadcrumbing extends React.Component {
render() {
return (
  <Grid>
<div className="Breadcrumb-holder">
<Breadcrumb>
  <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
 
  <Breadcrumb.Item active> Shopping Cart</Breadcrumb.Item>
</Breadcrumb>
</div>
</Grid>
  
)
}
}
export default Breadcrumbing;


// WEBPACK FOOTER //
// ./src/Components/Breadcrumbing/Breadcrumbing.jsx